<div>
  <mic-breadcrumb id="customer-assign-breadcrumb">
    <!-- Dynamic breadcrumbs when provided as input -->
    @if (breadcrumbLinks && breadcrumbLinks.length > 0) { @for (breadcrumb of breadcrumbLinks; track breadcrumb) {
    <mic-breadcrumb-link [link]="breadcrumb.link" [label]="breadcrumb.label" [icon]="breadcrumb.icon"> </mic-breadcrumb-link>
    }
    <mic-breadcrumb-link label="{{ translationService.translate('assignToCustomerMenuText') }}"></mic-breadcrumb-link>
    }

    <!-- Default breadcrumbs when no input provided -->
    @if (!breadcrumbLinks || breadcrumbLinks.length === 0) {
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('customerAssignText') }}"></mic-breadcrumb-link>
    }
  </mic-breadcrumb>

  <h3>{{ translationService.translate('assignToCustomerMenuText') }}</h3>

  <mat-card class="search-card mt-5">
    <div class="w-full flex flex-row items-center justify-between">
      <div class="w-full justify-self-start">
        <mat-form-field class="w-1on3" subscriptSizing="dynamic">
          <mat-label>Search by Customer Code or Customer Name</mat-label>
          <input type="text" matInput [formControl]="search" autocomplete="off" (keydown.enter)="onSearchClick()" />
          <button (click)="onSearchClick()" mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="flex pr-5">
        <button mat-flat-button color="primary" (click)="onCancelClick()">Cancel</button>
      </div>
      <div class="flex">
        <span [matTooltip]="!isCustomerSelected ? translationService.translate('selectCustomersText') : ''" matTooltipPosition="below">
          <button mat-flat-button color="primary" (click)="onAssignClick()" [disabled]="!isCustomerSelected" [loading]="assignProcessing">
            Assign
          </button>
        </span>
      </div>
    </div>
  </mat-card>

  <div class="cam-table mt-2">
    <mic-table
      #paginatedTable
      class="table-stripped"
      [config]="tableConfig"
      [filtersConfig]=""
      [fetcher]="fetcher"
      [uniqueKey]="'customerPk'"
    >
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
      </ng-container>

      <ng-container *micTableActions="let items">
        <div class="footer flex flex-row justify-center items-center">
          <div class="mr-4">
            <span class="selection">{{ selection.length }}</span> {{ translationService.translate('itemsSelectionText') }}
          </div>
        </div>
      </ng-container>
    </mic-table>
  </div>

  <mic-modal class="modalC" #assignModal (result)="onAssignModalClosed($event)"></mic-modal>
  <ng-template #assignContent>
    Are you sure you want to assign <b>{{ currentDataObject | descProperty }}</b> to <b>{{ selection.length }}</b> customer(s)?
  </ng-template>
</div>
